/**
 * assets/card-bundle-selector.js  (v3)
 *
 * WHY THIS VERSION EXISTS:
 * This theme (Horizon) uses a custom <add-to-cart-component> web component
 * with its own internal logic for deciding which variant to submit. There
 * is no input[name="id"] we can write to on the card — DevTools confirmed
 * the only nearby hidden input is name="product-id" (the PRODUCT id, not
 * a variant id). Writing to DOM fields the component doesn't read is why
 * every previous version silently failed here.
 *
 * FIX: intercept the actual network call to Shopify's cart endpoint
 * (/cart/add or /cart/add.js) and correct the variant id in the outgoing
 * request body, right before it's sent. This works no matter how the
 * component internally decides what to submit, because every path — no
 * matter the framework — ends at this one network call.
 */
(function () {
  if (window.__cardBundleSelectorLoaded) return;
  window.__cardBundleSelectorLoaded = true;

  var WRAPPER = ".card_bundle_wrapper";
  var ITEM = ".card_bundle_item";
  var ADD_BUTTON = '.add-to-cart-button, add-to-cart-component, button[name="add"], [data-add-to-cart]';

  function getCard(wrapper) {
    return wrapper.closest(".card-wrapper, .product-card, .grid__item, [class*='card-']") ||
           wrapper.parentElement;
  }

  function findOutside(card, wrapper, selectors) {
    var nodes = card.querySelectorAll(selectors);
    for (var i = 0; i < nodes.length; i++) {
      if (!wrapper.contains(nodes[i])) return nodes[i];
    }
    return null;
  }

  // ── Visual state + price/badge updates (unchanged, this part was fine) ──

  function applyVariant(wrapper, item) {
    var variantId = item.dataset.variantId;
    if (!variantId) return;

    wrapper.querySelectorAll(ITEM).forEach(function (i) {
      i.classList.remove("active");
      i.setAttribute("aria-checked", "false");
    });
    item.classList.add("active");
    item.setAttribute("aria-checked", "true");
    wrapper.setAttribute("data-selected-variant", variantId);

    var card = getCard(wrapper);
    if (!card) return;

    var saleEl = item.querySelector(".card_bundle_sale");
    var compareEl = item.querySelector(".card_bundle_compare");
    var mainSale = findOutside(card, wrapper,
      '.price__sale .price-item--sale, .price-item--sale, [class*="price-sale"], .price__regular .price-item--regular');
    var mainCompare = findOutside(card, wrapper,
      '.price__sale .price-item--regular, s.price-item--regular, [class*="price-compare"], .price__sale s');

    if (mainSale && saleEl) mainSale.textContent = saleEl.textContent.trim();
    if (mainCompare) {
      if (compareEl) {
        mainCompare.textContent = compareEl.textContent.trim();
        mainCompare.style.display = "";
      } else {
        mainCompare.style.display = "none";
      }
    }

    var price = parseInt(item.dataset.price, 10);
    var compare = parseInt(item.dataset.comparePrice, 10);
    var badge = findOutside(card, wrapper,
      '[data-discount-badge], .card__discount, .badge--sale, [class*="discount"]');
    if (badge && price && compare && compare > price) {
      badge.textContent = Math.round(((compare - price) / compare) * 100) + "%";
      badge.style.display = "";
    } else if (badge) {
      badge.style.display = "none";
    }

    var link = findOutside(card, wrapper, 'a[href*="/products/"]');
    if (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set("variant", variantId);
        link.href = url.pathname + url.search;
      } catch (e) {}
    }

    card.dispatchEvent(new CustomEvent("variant:changed", {
      bubbles: true,
      detail: { variantId: variantId }
    }));
  }

  document.addEventListener("click", function (e) {
    var item = e.target.closest(ITEM);
    if (!item || item.classList.contains("sold-out")) return;
    var wrapper = item.closest(WRAPPER);
    if (!wrapper) return;
    applyVariant(wrapper, item);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var item = e.target.closest(ITEM);
    if (!item || item.classList.contains("sold-out")) return;
    e.preventDefault();
    item.click();
  });

  function init(root) {
    (root || document).querySelectorAll(WRAPPER).forEach(function (wrapper) {
      if (wrapper.dataset.bundleInit === "true") return;
      wrapper.dataset.bundleInit = "true";

      wrapper.setAttribute("role", "radiogroup");
      wrapper.querySelectorAll(ITEM).forEach(function (i) {
        i.setAttribute("role", "radio");
        if (!i.classList.contains("sold-out")) i.setAttribute("tabindex", "0");
      });

      if (wrapper.querySelector(ITEM + ".active")) return;
      var first = wrapper.querySelector(ITEM + ":not(.sold-out)");
      if (first) applyVariant(wrapper, first);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(); });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (e) { init(e.target); });

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { init(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // ── NEW in v3: capture which card's Add-to-cart was clicked ──
  //
  // Right before the click reaches the web component's own handler, note
  // which card it belongs to and what pack was selected on that card.
  // This is stored briefly (4s window) so the network interceptor below
  // knows which variant id to substitute into the request that follows.

  window.__pendingCartVariant = null;

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(ADD_BUTTON);
    if (!btn) return;

    var card = btn.closest(".card-wrapper, .product-card, .grid__item, [class*='card-']");
    if (!card) return;

    var wrapper = card.querySelector(WRAPPER);
    if (!wrapper) return; // this card has no bundle selector, nothing to correct

    var variantId = wrapper.dataset.selectedVariant || wrapper.getAttribute("data-selected-variant");
    if (!variantId) return;

    window.__pendingCartVariant = { id: variantId, ts: Date.now() };
  }, true);

  // ── NEW in v3: correct the outgoing /cart/add request ──

  function isCartAddUrl(url) {
    return typeof url === "string" && url.indexOf("/cart/add") !== -1;
  }

  function pendingIsFresh() {
    return window.__pendingCartVariant && (Date.now() - window.__pendingCartVariant.ts) < 4000;
  }

  function rewriteFormData(fd, variantId) {
    fd.set("id", variantId);
    return fd;
  }

  function rewriteUrlEncoded(str, variantId) {
    if (str.indexOf("id=") !== -1) {
      return str.replace(/id=[^&]*/, "id=" + encodeURIComponent(variantId));
    }
    return str + (str ? "&" : "") + "id=" + encodeURIComponent(variantId);
  }

  function rewriteJson(str, variantId) {
    try {
      var parsed = JSON.parse(str);
      if (parsed && Array.isArray(parsed.items) && parsed.items.length) {
        parsed.items[0].id = Number(variantId);
      } else if (parsed && typeof parsed === "object") {
        parsed.id = Number(variantId);
      }
      return JSON.stringify(parsed);
    } catch (e) {
      return null; // not JSON
    }
  }

  function correctBody(body, variantId) {
    if (!body) return body;
    if (body instanceof FormData) return rewriteFormData(body, variantId);
    if (body instanceof URLSearchParams) {
      body.set("id", variantId);
      return body;
    }
    if (typeof body === "string") {
      var asJson = rewriteJson(body, variantId);
      if (asJson !== null) return asJson;
      return rewriteUrlEncoded(body, variantId);
    }
    return body;
  }

  // fetch()
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      if (isCartAddUrl(url) && pendingIsFresh()) {
        init = init || {};
        init.body = correctBody(init.body, window.__pendingCartVariant.id);
        window.__pendingCartVariant = null; // one-shot
      }
    } catch (e) {
      // never let our correction attempt break the real request
    }
    return originalFetch.call(this, input, init);
  };

  // XMLHttpRequest (fallback for older/alternate implementations)
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isCartAdd = isCartAddUrl(url);
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (this.__isCartAdd && pendingIsFresh()) {
        body = correctBody(body, window.__pendingCartVariant.id);
        window.__pendingCartVariant = null;
      }
    } catch (e) {}
    return originalSend.call(this, body);
  };
})();